import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/storefrontCustomerProfilesWorkspaceCapability/domain/StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";
export type StorefrontCustomerProfilesWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.storefrontCustomerProfiles> & {
    fixedUdoTemplates: {
        [StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey.profile]: {
            udoAdditionalColumnIds: {
                companyName: Uuid;
                email: Uuid;
                fullName: Uuid;
                phone: Uuid;
                status: Uuid;
            };
        };
        [StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey.address]: {
            udoAdditionalColumnIds: {
                address: Uuid;
                addressType: Uuid;
                city: Uuid;
                countryId: Uuid;
                ottokartStorefrontCustomerId: Uuid;
                pinCode: Uuid;
                state: Uuid;
                status: Uuid;
            };
        };
        [StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey.procurementContact]: {
            udoAdditionalColumnIds: {
                companyRole: Uuid;
                email: Uuid;
                firstName: Uuid;
                isDefault: Uuid;
                isPrimary: Uuid;
                lastName: Uuid;
                ottokartStorefrontCustomerId: Uuid;
                phoneNumber: Uuid;
                status: Uuid;
            };
        };
    };
};
export const storefrontCustomerProfilesWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey.profile]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                companyName: uuidZodValidator,
                email: uuidZodValidator,
                fullName: uuidZodValidator,
                phone: uuidZodValidator,
                status: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
        [StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey.address]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                address: uuidZodValidator,
                addressType: uuidZodValidator,
                city: uuidZodValidator,
                countryId: uuidZodValidator,
                ottokartStorefrontCustomerId: uuidZodValidator,
                pinCode: uuidZodValidator,
                state: uuidZodValidator,
                status: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
        [StorefrontCustomerProfilesWorkspaceCapabilityUdoTemplateKey.procurementContact]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                companyRole: uuidZodValidator,
                email: uuidZodValidator,
                firstName: uuidZodValidator,
                isDefault: uuidZodValidator,
                isPrimary: uuidZodValidator,
                lastName: uuidZodValidator,
                ottokartStorefrontCustomerId: uuidZodValidator,
                phoneNumber: uuidZodValidator,
                status: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<StorefrontCustomerProfilesWorkspaceCapabilityUdoBindings>;
